export function getAttachmentPermissionLevelFromSharingLinkKind(linkKind) {
    switch (linkKind) {
        case 5 /* AnonymousEdit */:
            return 4 /* AnonymousEdit */;
        case 4 /* AnonymousView */:
            return 3 /* AnonymousView */;
        case 3 /* OrganizationEdit */:
            return 6 /* OrganizationEdit */;
        case 2 /* OrganizationView */:
            return 5 /* OrganizationView */;
        default:
            return 0 /* None */;
    }
}
//# sourceMappingURL=getAttachmentPermissionLevelFromSharingLinkKind.js.map